import { getUsageTrends } from "../api/usageTrends.api";

export async function fetchUsageTrends(params) {
	const raw = await getUsageTrends(params);

	// New preferred shape: { usageTrends: [{ month, content1, content2 } or { label, ... }] }
	const usageTrends = raw?.data?.usageTrends || raw?.usageTrends;
	let data;
	if (Array.isArray(usageTrends)) {
		const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
		const dayNamesMondayFirst = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
		data = usageTrends.map(d => {
			let label =
				d.label || d.month || d.week || d.year;
			if (!label && d.timestamp) {
				const ts = new Date(d.timestamp);
				if (params?.interval === "day") {
					const jsDay = ts.getDay(); // 0..6 Sun..Sat
					label = dayNamesMondayFirst[(jsDay + 6) % 7];
				} else if (params?.interval === "month") {
					label = monthNames[ts.getMonth()];
				} else if (params?.interval === "year") {
					label = String(ts.getFullYear());
				}
			}
			const content1 = Number(d.content1 ?? d.value ?? d.visits ?? 0);
			const content2 = Number(d.content2 ?? Math.max(0, content1 * 0.33));
			const content3 = Math.round(((Number(content1) + Number(content2)) / 3));
			return {
				month: label,
				content1,
				content2,
				content3
			};
		});
	} else {
		// Fallback to older time-series format
		const series = raw?.data?.series || raw?.series || [];
		data = series.map(p => {
			const ts = new Date(p.timestamp);
			const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
			const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
			let label;
			if (params?.interval === "day") {
				label = dayNames[ts.getDay()];
			} else if (params?.interval === "month") {
				label = monthNames[ts.getMonth()];
			} else if (params?.interval === "year") {
				label = String(ts.getFullYear());
			} else {
				label = monthNames[ts.getMonth()];
			}
			const val = p.value ?? p.visits ?? p.sessions ?? p.questions ?? 0;
			const content1 = Math.round(val * 0.6);
			const content2 = Math.round(val * 0.4 - (val * 0.2));
			const content3 = Math.round(val * 0.25);
			return { month: label, content1, content2, content3 };
		});
	}
	return { data, raw };
}


